export const getPlaceholderText = (
  formDisabled,
  { property: { placeholder, label } },
  intl
) =>
  !formDisabled &&
  (placeholder
    ? placeholder.fallback
    : intl.formatMessage({
        id: label.id,
        defaultMessage: label.fallback,
      }));
